<template>
    <div class="custom-container">
        <div class="custom-avatar" @click="clickAvatar">
            <el-avatar fit="fill" :src="sex === 2 ? avatarUrl2 : avatarUrl1"></el-avatar>
        </div>
        <div class="custom-menus">
            <div
                class="menu"
                v-for="(menu, index) in menus"
                :key="index"
                :class="{'menu-active': activeMenuIndex === index}"
                @click="changeMenu(index)"
                @mouseover="hoverMenu(index)"
                @mouseleave="resetHover">
                <i :class="menu.icon" :style="getIconStyle(index)"></i>
                <span>{{menu.title}}</span>
            </div>
        </div>
        <div class="custom-setting">
            <div class="menu" @click="clickSetting()"
                @mouseover="hoverSetting"
                @mouseleave="resetSetting">
                <i class="el-icon-setting" :class="{'rotate': isHovered}"></i>
                <span>背景</span>
            </div>
        </div>
    </div>
</template>
<script>
import classifySearch from "./classifySearch.vue";
import avatar1 from '../../static/image/avatar1.png';
import avatar2 from '../../static/image/avatar2.png';

export default {
    props: ['active', 'searchQuery', 'isMember', 'sex'],
    data() {
        return {
            avatarUrl1: avatar1,
            avatarUrl2: avatar2,
            activeMenuIndex: 0,
            hoverMenuIndex: null,
            menus: [
                {
                    'title': '器件展示',
                    'icon': 'el-icon-menu'
                },
                {
                    'title': '标准解析',
                    'icon': 'el-icon-document'
                },
                {
                    'title': '通用规范',
                    'icon': 'el-icon-collection'
                },
                {
                    'title': '常用网站',
                    'icon': 'el-icon-s-shop'
                }
            ],
            isHovered: false,
        }
    },
    computed: {
        iconStyle() {
            return this.hoverMenuIndex !== null
                ? { transform: 'scale(1.5)', transition: 'transform 0.3s ease' }
                : { transform: 'scale(1)', transition: 'transform 0.3s ease' };
        }
    },
    watch: {
        'active': {
            handler(value) {
                this.activeMenuIndex = Number(value || 1) - 1;
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        changeInput(val) {
            this.$emit('changeInput', val);
        },
        clickItem(index) {
            this.$emit('clickItem', index);
        },
        changeMenu(index) {
            if (this.isMember && (index !== 0 && index !== 3)) {
                this.$notify.warning('模块暂未开放')
                return;
            }
            this.activeMenuIndex = index;
            this.$emit('clickItem', `${index + 1}`);
        },
        hoverMenu(index) {
            this.hoverMenuIndex = index;
        },
        resetHover() {
            this.hoverMenuIndex = null;
        },
        getIconStyle(index) {
            return this.hoverMenuIndex === index
            ? { transform: 'scale(1.2)', transition: 'transform 0.3s ease' }
            : { transform: 'scale(1)', transition: 'transform 0.3s ease' };
        },
        hoverSetting() {
            this.isHovered = true;
        },
        resetSetting() {
            this.isHovered = false;
        },
        clickSetting() {
            this.$emit('clickSetting');
        },
        clickAvatar() {
            this.$emit('clickAvatar');
        }
    },
    components: {classifySearch}
}
</script>

<style lang="scss" scoped>

.custom-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.custom-avatar {
  margin: 20px 0;
  cursor: pointer;
}

.custom-menus {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.menu {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 6px 0;

    i {
      font-size: 30px;
      margin: 6px 0;
    }
  }

  .menu-active {
    background-color: #ffffff26;
  }

.custom-setting {
  margin-top: auto;
  padding-bottom: 35px;
}

.el-icon-setting {
    transition: transform 0.3s ease-in-out;
}

.el-icon-setting.rotate {
    transform: rotate(-90deg);
}
</style>


// WEBPACK FOOTER //
// src/views/classify/classifyLeftMenu.vue